import { InstagramPostDTO } from 'infrastructure/dtos/instagramPost';
import { InstagramPost } from 'domains/instagramPost';
import { MediaResponseDTO } from 'infrastructure/dtos/media';
import { MediaMapper } from '../media/MediaMapper';

export class InstagramPostMapper {
  static fromDTO(dto: InstagramPostDTO): InstagramPost {
    const media: MediaResponseDTO = JSON.parse(dto.media);

    return new InstagramPost(
      dto.caption,
      dto.category,
      new Date(dto.created_at),
      dto.id,
      dto.instagram_post_id,
      MediaMapper.fromDTO(media),
      dto.rejected_reason,
      dto.status,
      new Date(dto.updated_at),
      dto.url,
      dto.user_id
    );
  }
}
